import React from 'react';
import { Formik } from 'formik';
import { Container, Row, Col, Form } from 'react-bootstrap';
import Button from '../common/button';
import { Link } from 'react-router-dom';
import { useEmailRecovery } from './hooks';
import { Loader } from 'semantic-ui-react';
import Skeleton from './EamilRecoverySkeleton';
import GenericButton from '../../../Components/GenericButton/GenericButton';

const EmailRecovery = ({
  handleEmailInput,
  setUserDetails,
  currentStep,
  nextStep,
  passwordRules,
  skeletonLoader,
}) => {
  const { schema, checkUser, loader } = useEmailRecovery({
    setUserDetails,
    passwordRules,
  });

  return currentStep === 1 ? (
    <Col
      md={8}
      className="email-recovery-container email-recovery-container-box"
    >
      <Row className="mb-4">
        <Col md={12} className="mt-3">
          <p>
            To reset password, please enter the email you have used to register.
            To validate your account, you may be asked for additional
            information.
          </p>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Formik
            validationSchema={schema}
            initialValues={{ email: '' }}
            onSubmit={(values, actions) => {
              actions.setStatus(undefined);
              checkUser(values.email)
                .then(() => {
                  nextStep();
                  console.log('next step');
                })
                .catch((error) => {
                  actions.setStatus({
                    email: error,
                  });
                });
            }}
          >
            {({
              values,
              touched,
              errors,
              status,
              handleSubmit,
              handleChange,
              handleBlur,
              setStatus,
            }) => {
              return (
                <Form onSubmit={handleSubmit}>
                  {skeletonLoader ? (
                    <Skeleton />
                  ) : (
                    <Form.Group className="mb-5">
                      <Form.Label className="mb-0">Registered Email</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        placeholder=""
                        className={status && status.email ? 'is-invalid' : ''}
                        value={values.email}
                        isInvalid={errors.email}
                        onChange={(e) => {
                          handleChange(e);
                          const setEmail = e.currentTarget.value.trim();
                          handleEmailInput(setEmail);
                          setStatus({ email: '' });
                        }}
                        onBlur={(e) => {
                          handleBlur(e);
                          const setEmail = e.currentTarget.value.trim();
                          handleEmailInput(setEmail);
                          setStatus({ email: '' });
                          console.log('status', status);
                          console.log('errors', errors);
                        }}
                      />
                      {status && status.email ? (
                        <Form.Control.Feedback type="invalid" className="mt-1">
                          <span>{status.email}</span>
                        </Form.Control.Feedback>
                      ) : (
                        errors.email && (
                          <Form.Control.Feedback
                            type="invalid"
                            className="mt-1"
                          >
                            <span>{errors.email}</span>
                          </Form.Control.Feedback>
                        )
                      )}
                    </Form.Group>
                  )}
                  <Row>
                    <Col>
                      <Link to={'/admin'}>Return to Login</Link>
                    </Col>
                    <Col>
                      <GenericButton
                        type="submit"
                        variant="primary"
                        disable={loader}
                        className="float-right"
                      >
                        Continue
                      </GenericButton>
                    </Col>
                  </Row>
                  {/*{loader && (
                      <div className="custom-loader mt-0 mt-md-3 mt-lg-4 d-flex justify-content-end">
                        <div className="loader-icon position-relative mr-4">
                          <Loader
                            className="text-dark font-weight-bold loader-color marginTop-Login-loader"
                            size="small"
                            active
                          />
                        </div>
                        <div className="text-dark font-weight-bold">Verifying email...</div>
                      </div>
                    )} */}
                </Form>
              );
            }}
          </Formik>
        </Col>
      </Row>
    </Col>
  ) : null;
};
export default EmailRecovery;
